<template>
  <v-dialog v-model="dialog" max-width="600px">
    <template v-slot:activator="{ on:dialog }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on:tooltip }">
          <v-btn color="blue"
                 dark
                 small
                 :fab="$vuetify.breakpoint.mdAndDown"
                 v-on="{...dialog, ...tooltip}">
            <v-icon :left="$vuetify.breakpoint.lgAndUp">mdi-plus</v-icon>
            <span class="d-none d-lg-block">Добавить абонемент</span>
          </v-btn>
        </template>
        <span>Добавить новый абонемент</span>
      </v-tooltip>
    </template>
    <v-card class="modal-card">
      <v-card-title class="pa-6">Добавить абонемент</v-card-title>
      <ValidationObserver ref="form" tag="div">
        <v-card-text class="pa-6">
          <v-row>
            <v-col cols="12" class="pb-0">
              <ValidationProvider name="card_type_id"
                                  rules="required"
                                  v-slot="{ errors }"
                                  tag="div"
                                  class="client-info-group">
                <v-autocomplete
                  v-model="cardType"
                  :items="cardTypes"
                  item-text="name"
                  :return-object="true"
                  required
                  label="Вид абонемента"
                  @change="onCardTypeChange"
                  outlined
                  :error-messages="errors"
                />
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="pb-0">
              <v-text-field
                type="number"
                v-model="visits_limit"
                required
                label="Количество посещений"
                outlined
                hint="Поставить 0 или оставить пустым если нет лимита"
                persistent-hint
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" class="pb-0">
              <v-menu
                v-model="startAtPicker"
                :close-on-content-click="false"
                :nudge-right="0"
                :nudge-top="25"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{on}">
                  <v-text-field
                    v-model="start_at"
                    label="Действителен с"
                    append-icon="mdi-calendar-month"
                    readonly
                    required
                    v-on="on"
                    outlined
                  />
                </template>
                <v-date-picker
                  v-model="start_at"
                  locale="ru-RU"
                  first-day-of-week="1"
                  @input="onInputStartAtPicker"
                />
              </v-menu>
            </v-col>
            <v-col cols="12" sm="6" class="pb-0">
              <v-menu
                v-model="endAtPicker"
                :close-on-content-click="false"
                :nudge-right="0"
                :nudge-top="25"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{on}">
                  <v-text-field
                    v-model="end_at"
                    label="Действителен по"
                    append-icon="mdi-calendar-month"
                    readonly
                    required
                    v-on="on"
                    outlined
                  />
                </template>
                <v-date-picker
                  v-model="end_at"
                  locale="ru-RU"
                  @input="endAtPicker = false"
                  first-day-of-week="1"
                />
              </v-menu>
            </v-col>
          </v-row>
        </v-card-text>
      </ValidationObserver>
      <v-card-actions class="px-6 py-5">
        <v-spacer></v-spacer>
        <v-btn depressed dark color="blue-grey" @click="close" min-width="120" class="mx-2">Закрыть</v-btn>
        <v-btn depressed color="success" @click="save" min-width="120">Добавить</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import cardApi from '../api/card.api';
  import dayjs from 'dayjs';
  import { mapState } from 'vuex';

  function initialResettableState() {
    return {
      dialog       : false,
      cardType     : '',
      visits_limit : null,
      start_at     : null,
      end_at       : null,
      startAtPicker: false,
      endAtPicker  : false,
      adding       : false,
    };
  }

  export default {
    name    : 'CardAddDialog',
    props   : {
      client: {
        required: true,
        type    : Object,
      }
    },
    data() {
      return {
        ...initialResettableState(),
      };
    },
    computed: {
      ...mapState({
        cardTypes: state => state['card-types'].items,
      })
    },
    watch   : {
      dialog() {
        if (true === this.dialog) {
          this.onOpen();
        } else {
          this.onClose();
        }
      }
    },
    created() {

    },
    methods : {
      onOpen() {
        this.visits_limit = '';
        this.cardType     = null;

        this.start_at = dayjs().format('YYYY-MM-DD');
        this.end_at   = dayjs().add(1, 'month').format('YYYY-MM-DD');
      },
      onClose() {
        Object.assign(this.$data, initialResettableState());
        this.$refs.form.reset();
      },
      onCardTypeChange() {
        this.visits_limit = this.cardType.visits_limit ? this.cardType.visits_limit : '';
        this.refreshEndAt();
      },
      async save() {
        if (false === await this.$refs.form.validate() || this.adding) {
          return;
        }

        this.adding = true;
        this.$store.commit('setLoading', true);

        cardApi.create({
          card_type_id: this.cardType ? this.cardType.id : '',
          client_id   : this.client.id,
          visits_limit: this.visits_limit,
          start_at    : this.start_at,
          end_at      : this.end_at,
        }).then(() => {
          this.$store.dispatch('clients/refresh');
          this.$emit('saved');
          this.close();
        }).catch(({ response }) => {
          this.$refs.form.setErrors(response.data.errors);
        }).finally(() => {
          this.$store.commit('setLoading', false);
          this.adding = false;
        });
      },
      close() {
        this.dialog = false;
      },
      onInputStartAtPicker() {
        this.startAtPicker = false;
        this.refreshEndAt();
      },
      refreshEndAt() {
        if (this.cardType) {
          this.end_at = dayjs(this.start_at, 'YYYY-MM-DD').add(this.cardType.duration, this.cardType.duration_unit).format('YYYY-MM-DD');
        }
      }
    }
  };
</script>

<style lang="scss">
  .modal-card {

    .v-card__title {
      font-size: 20px;
      line-height: 26px;
      text-align: center;
      justify-content: center;
      background-color: #E1F5FE;

      .subtitle {

      }
    }

    .v-card__actions {
      background-color: #f1f1f1;
    }


    .message-date {
      padding: 4px 16px;
      text-align: center;
      background-color: #1E88E5;
      color: #fff;
      font-weight: 500;
      letter-spacing: 0.5px;
    }


    .message-group {
      margin-bottom: 30px;
    }


    .message-heading {
      display: flex;
      align-items: center;
      margin-bottom: 12px;

      .message-heading__title {
        color: #000;
        font-size: 16px;
        line-height: 20px;
        font-weight: 500;
      }

      .message-heading__actions {

        .v-btn--collapse {

          &.collapsed {
            .v-btn__content {
              transform: rotate(0deg);
            }
          }

          .v-btn__content {
            transform: rotate(180deg);
            transition: transform 0.2s ease;
          }
        }
      }
    }

    .message-clients {
      border: 1px solid #ECEFF1;
      background-color: #FAFAFA;
      border-radius: 4px;
      padding: 8px 0;

      .v-slide-group__content {
        padding-left: 16px;
        padding-right: 8px;
      }
    }

    .message-text {
      border: 1px solid #ECEFF1;
      background-color: #FAFAFA;
      color: #37474F;
      border-radius: 4px;
      padding: 14px 16px;
      white-space: pre-wrap;
    }
  }
</style>
